<div class=" mt-4">
  <section>
      <div class="scrollmenu">
          <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
          <a [routerLink]="['/pos/customer/new']"> Customer </a>
          <a [routerLink]="['/pos/Employee/new']"> Employee </a>
          <a [routerLink]="['/pos/orders/new']"> Orders</a>
          <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
          <a [routerLink]="['/pos/category/new']"> Item-Category </a>
          <a [routerLink]="['/pos/item/new']"> Items </a>
          <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
          <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
          <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
          <a [routerLink]="['/pos/payment/new']"> Payment </a>
          <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
          <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/tip/new']"> Tips </a> -->

          <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
          <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
          <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
      </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
              <div class="col-md-12">
                  <div class="text-right py-2">
                    <button class="dash-btns btn" [routerLink]="['/pos/tips/manage']">Manage Tips </button>


                  </div>
              </div>
              <div class="col-md-7">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="text-center mb-5">
                                  <img src="assets/img/new/pos.svg" />
                              </div>
                              <div class="text-center">
                                  <!-- <a class="view-h gary-t mb-3">Tax Fee</a> -->
                                  <div class="col-md-12 " *ngIf="isNewTips">
                                    <h4  class="font20 gary-t pt-3">Lets create a New Tips here. </h4>
                                  </div>
                                  <div class="col-md-12 " *ngIf="isUpdateTips">
                                    <h4  class="font20 gary-t pt-3">Lets Update Tips here. </h4>
                                  </div>
                                   



                              </div>

                              <div class="py-3">
                                <form #fnewprepaidcard="ngForm">
                                  <div class="row mx-0">
                                    <!-- New Tips starts -->
                                    <div class="col-md-12" *ngIf="isNewTips">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                      
                                          <div class="row pt-2"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip1 Label *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip1 Label" id="Tip1Label" name="Tip1Label"
                                                  [formControl]="Tip1Label" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip1Label.invalid && (Tip1Label.dirty || Tip1Label.touched)">{{Tip1LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip1<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" id="EnableTip1 " name="EnableTip1 " (click)="EnableTip11()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2" *ngIf="hideEnableTip1">
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip1 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip1 Percentage" id="Tip1Percentage" name="Tip1Percentage"
                                                  [formControl]="Tip1Percentage" change="mychange(event)">
                      
                                              </div>
                      
                                              <span class="text-danger"
                                                *ngIf="Tip1Percentage.invalid && (Tip1Percentage.dirty || Tip1Percentage.touched)">{{Tip1PercentageError()}}</span>
                                              <span style="color:red;" *ngIf="isTip1Percentage">Tip1 Percentage Less Than 40</span>
                      
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip2 Label *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip2 Label" id="Tip2Label" name="Tip2Label"
                                                  [formControl]="Tip2Label" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip2Label.invalid && (Tip2Label.dirty || Tip2Label.touched)">{{Tip2LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip2<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" id="EnableTip2 " name="EnableTip2 " (click)="EnableTip21()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="hideEnableTip2"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip2 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip2 Percentage " id="Tip2Percentage" name="Tip2Percentage"
                                                  maxlength="10" [formControl]="Tip2Percentage" change="mychange(event)">
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip2Percentage.invalid && (Tip2Percentage.dirty || Tip2Percentage.touched)">{{Tip2PercentageError()}}
                                              </span>
                                              <span style="color:red;" *ngIf="isTip2Percentage">Tip2 Percentage Less Than 40</span>
                      
                      
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip3 Label *</label>
                                              <div class="form-group">
                      
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip3 Label " id="Tip3Label" name="Tip3Label"
                                                  [formControl]="Tip3Label">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip3Label.invalid && (Tip3Label.dirty || Tip3Label.touched)">{{Tip3LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip3<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" id="EnableTip3 " name="EnableTip3 " (click)="EnableTip31()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="hideEnableTip3"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip3 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip3 Percentage " id="Tip3Percentage" name="Tip3Percentage"
                                                  maxlength="10" [formControl]="Tip3Percentage" change="mychange(event)">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip3Percentage.invalid && (Tip3Percentage.dirty || Tip3Percentage.touched)">{{Tip3PercentageError()}}</span>
                      
                                              <span style="color:red;" *ngIf="isTip3Percentage">Tip3 Percentage Less Than 40</span>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                             
                                            </div>
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip4 Label *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip4 Label " id="Tip4Label" name="Tip4Label" maxlength="10"
                                                  [formControl]="Tip4Label">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip4Label.invalid && (Tip4Label.dirty || Tip4Label.touched)">{{Tip4LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip4<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" id="EnableTip4 " name="EnableTip4 " (click)="EnableTip41()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="hideEnableTip4"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip4 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip4 Percentage " id="Tip4Percentage" name="Tip4Percentage"
                                                  [formControl]="Tip4Percentage" change="mychange(event)">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip4Percentage.invalid && (Tip4Percentage.dirty || Tip4Percentage.touched)">{{Tip4PercentageError()}}
                                              </span>
                                              <div style="color:red;" *ngIf="isTip4Percentage">Tip4 Percentage Less Than 40</div>
                      
                      
                                            </div>
                                          </div>
                                          <!-- <div class="row pt-2">
                      
                        <div class="col-md-5 col-lg-5">
                          <label for="sel1">Enable Tip5<span
                                  class="text-danger">*</span></label>
                      </div>
                        
                        <div class="col-md-12">
                          <div >
                           
                            <input type="checkbox" [(ngModel)]="isEnableTip " id="EnableTip " name="EnableTip " (click)="EnableTips()"> 
                      
                          </div>
                         
                      </div>
                      </div> -->
                      
                      
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="paymentrecipt" color="primary"
                                              [disabled]="Tip1Label.invalid||Tip2Label.invalid ||Tip3Label.invalid ||Tip4Label.invalid ||isTip4Percentage||isTip3Percentage ||isTip2Percentage ||isTip1Percentage "
                                              (click)="savetips()">Submit</button>
                                            <!-- [disabled]="Tip1Label.invalid||Tip1Percentage.invalid||Tip2Label.invalid||Tip2Percentage.invalid ||Tip3Label.invalid ||Tip3Percentage.invalid||Tip4Label.invalid || Tip4Percentage.invalid " -->
                                          </div>
                      
                                        </div>
                                      </form>
                                    </div>
                                    <!-- Update Tips Starts -->
                                    <div class="col-md-12" *ngIf="isUpdateTips">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                      
                                          <div class="row pt-2"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip1 Label *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip1 Label" id="Tip1Label" name="Tip1Label"
                                                  [formControl]="Tip1Label" [(ngModel)]="rows.tip1Label" (keydown)="onKey()" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip1Label.invalid && (Tip1Label.dirty || Tip1Label.touched)">{{Tip1LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip1<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" [(ngModel)]="EnableTip1 " id="EnableTip1 " name="EnableTip1 "
                                                  (click)="EnableTip11()" (click)="onKey()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2" *ngIf="hidetip1Percentage"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip1 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip1 Percentage" [(ngModel)]="rows.tip1Percentage"
                                                  id="Tip1Percentage" name="Tip1Percentage" [formControl]="Tip1Percentage"
                                                  change="mychange(event)" [(ngModel)]="rows.tip1Percentage" (keydown)="onKey()">
                      
                                              </div>
                      
                                              <span class="text-danger"
                                                *ngIf="Tip1Percentage.invalid && (Tip1Percentage.dirty || Tip1Percentage.touched)">{{Tip1PercentageError()}}</span>
                                              <span style="color:red;" *ngIf="isTip1Percentage">Tip1 Percentage Less Than 40</span>
                      
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip2 Label *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip2 Label" id="Tip2Label" name="Tip2Label"
                                                  [(ngModel)]="rows.tip2Label" [formControl]="Tip2Label" (keydown)="onKey()" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip2Label.invalid && (Tip2Label.dirty || Tip2Label.touched)">{{Tip2LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip2<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" [(ngModel)]="EnableTip2 " id="EnableTip2 " name="EnableTip2 "
                                                  (click)="EnableTip21()" (click)="onKey()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="hidetip2Percentage">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Tip2 Percentage *</label>
                                            </div>
                                             
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip2 Percentage " [(ngModel)]="rows.tip2Percentage"
                                                  id="Tip2Percentage" name="Tip2Percentage" maxlength="10" [formControl]="Tip2Percentage"
                                                  change="mychange(event)" (keydown)="onKey()" [(ngModel)]="rows.tip2Percentage">
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip2Percentage.invalid && (Tip2Percentage.dirty || Tip2Percentage.touched)">{{Tip2PercentageError()}}
                                              </span>
                                              <span style="color:red;" *ngIf="isTip2Percentage">Tip2 Percentage Less Than 40</span>
                      
                      
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2">
                      
                                            
                                            <div class="col-md-12">
                                              <label for="sel1">Tip3 Label *</label>
                                              <div class="form-group">
                      
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip3 Label " id="Tip3Label" name="Tip3Label"
                                                  [(ngModel)]="rows.tip3Label" [formControl]="Tip3Label" (keydown)="onKey()">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip3Label.invalid && (Tip3Label.dirty || Tip3Label.touched)">{{Tip3LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip3<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-7 col-lg-7">
                                              <div>
                      
                                                <input type="checkbox" [(ngModel)]="EnableTip3 " id="EnableTip3 " name="EnableTip3 "
                                                  (click)="EnableTip31()" (click)="onKey()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                                          <input type="hidden" [(ngModel)]="rows.id" id="id" name="id" [formControl]="id">
                                          <div class="row pt-2" *ngIf="hidetip3Percentage"> 
                                            <div class="col-md-12">
                                              <label for="sel1">Tip3 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip3 Percentage " [(ngModel)]="rows.tip3Percentage"
                                                  id="Tip3Percentage" name="Tip3Percentage" [(ngModel)]="rows.tip3Percentage" maxlength="10"
                                                  [formControl]="Tip3Percentage" change="mychange(event)" (keydown)="onKey()">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip3Percentage.invalid && (Tip3Percentage.dirty || Tip3Percentage.touched)">{{Tip3PercentageError()}}</span>
                      
                                              <span style="color:red;" *ngIf="isTip3Percentage">Tip3 Percentage Less Than 40</span>
                      
                                            </div>
                                          </div>
                                          <input type="hidden" [(ngModel)]="rows.id" id="id" name="id" [formControl]="id">
                                          <input type="hidden" [(ngModel)]="rows.dateTime" id="datetime" name="datetime"
                                            [formControl]="dateTime">
                      
                      
                                          <div class="row pt-2"> 
                                            <div class="col-md-12">
                                              <label for="sel1">Tip4 Label *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip4 Label " id="Tip4Label" name="Tip4Label" maxlength="10"
                                                  [formControl]="Tip4Label" [(ngModel)]="rows.tip4Label" (keydown)="onKey()">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip4Label.invalid && (Tip4Label.dirty || Tip4Label.touched)">{{Tip4LabelError()}}</span>
                      
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2">
                      
                                            <div class="col-md-5 col-lg-5">
                                              <label for="sel1">Enable Tip4<span class="text-danger"></span></label>
                                            </div>
                                             
                                            <div class="col-md-12">
                                              <div>
                      
                                                <input type="checkbox" [(ngModel)]="EnableTip4 " id="EnableTip4 " name="EnableTip4 "
                                                  (click)="EnableTip41()" (click)="onKey()">
                      
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="hidetip4Percentage"> 
                                             
                                            <div class="col-md-12">
                                              <label for="sel1">Tip4 Percentage *</label>
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control" placeholder="Tip4 Percentage " [(ngModel)]="rows.tip4Percentage"
                                                  id="Tip4Percentage" name="Tip4Percentage" [formControl]="Tip4Percentage"
                                                  change="mychange(event)" (keydown)="onKey()">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Tip4Percentage.invalid && (Tip4Percentage.dirty || Tip4Percentage.touched)">{{Tip4PercentageError()}}
                                              </span>
                                              <div style="color:red;" *ngIf="isTip4Percentage">Tip4 Percentage Less Than 40</div>
                      
                      
                                            </div>
                                          </div>
                                          <!-- <div class="row pt-2">
                      
                          <div class="col-md-5 col-lg-5">
                            <label for="sel1">Enable Tip5<span
                                    class="text-danger">*</span></label>
                        </div>
                          
                          <div class="col-md-12">
                            <div >
                             
                              <input type="checkbox" [(ngModel)]="isEnableTip " id="EnableTip " name="EnableTip " (click)="EnableTips()"> 
                      
                            </div>
                           
                        </div>
                      </div> -->
                      
                      
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="paymentrecipt" color="primary"
                                              [disabled]="Tip1Label.invalid||Tip2Label.invalid ||Tip3Label.invalid ||Tip4Label.invalid ||isTip1Percentage||isTip2Percentage||isTip3Percentage||isTip4Percentage ||!isReadytoUpdatetips"
                                              (click)="updatetips()">Update</button>
                                            <!-- [disabled]="Tip1Label.invalid||Tip1Percentage.invalid||Tip2Label.invalid||Tip2Percentage.invalid ||Tip3Label.invalid ||Tip3Percentage.invalid||Tip4Label.invalid || Tip4Percentage.invalid " -->
                                          </div>
                      
                                        </div>
                                      </form>
                                    </div> 
                                  </div>
                                </form> 
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-5">
                <div class="text-center mb-5">
                  <img src="assets/img/new/pos.svg" />
              </div>
              </div>
          </div>
      </div>
  </section>

</div>





<!-- <section  >
  <div class="block-header">
    <div class="">
      <div class="row ">
        <div class="col-md-12  p-0">
          <h2 class="poppins font-weight-bold pl-2"> Tips</h2>
        </div>
        <div class=" col-md-5 px-6 col-sm-12 p-0">

          <div class="breadcrumb flat">
            <a [routerLink]="['/pos']">
               Home
            </a>
            <a href="#" class="active"> Tips</a>
          </div>
        </div>
        <div class="col-md-7">
          <div class="float-right">

          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
          <div class="row mx-0">
            

          </div>
         
        </div>
      </div>
    </div>
  </div>
</section> -->